import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { InMemoryScrollingFeature, InMemoryScrollingOptions, provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { coreProviders, coreImports } from './core/core.provider';
import { ChunkLoadRecoveryService } from './core/services/chunk-load-recovery.service';
import { provideSentry } from './core/sentry';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};
const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, inMemoryScrollingFeature),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideSentry(),
    {
      provide: APP_INITIALIZER,
      useFactory: (recovery: ChunkLoadRecoveryService) => () => recovery.init(),
      deps: [ChunkLoadRecoveryService],
      multi: true,
    },
    importProvidersFrom(...coreImports),
    ...coreProviders
  ],
};
